export const TABLE_TOTAL_SUMMARY_TYPE = Symbol('totalSummary');
export const TABLE_GROUP_SUMMARY_TYPE = Symbol('groupSummary');
export const TABLE_TREE_SUMMARY_TYPE = Symbol('treeSummary');
